import { onActivated, onDeactivated, onUnmounted, ref, watch } from 'vue';

/** 覆盖浏览器标签；有值时 useTitle 不再拼接「 - 则形」 */
export const customDocumentTitle = ref<string | undefined>();

/**
 * 用业务名称覆盖浏览器标签（document.title）。
 * 未算出标题时沿用默认「路由标题 - 则形」。
 */
export function useCustomDocumentTitle(getTitle: () => string | undefined) {
  const apply = () => {
    customDocumentTitle.value = getTitle();
  };

  const clear = () => {
    customDocumentTitle.value = undefined;
  };

  watch(getTitle, apply, { immediate: true });
  onActivated(apply);
  onDeactivated(clear);
  onUnmounted(clear);
}
